import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import { useParams } from 'react-router-dom';
import styles from './index.module.less';
export const DescriptionTab = ({ className, activities, ...rest }) => {
    const params = useParams();
    const index = parseInt(params.index, 10);
    const activity = activities[index];
    if (!activity)
        return null;
    return (_jsx("div", { className: classnames(className, styles.description), ...rest, children: activity.body }));
};
